<template>
	<div>
		<nav class="sb-topnav navbar navbar-expand navbar-dark bg-dark">
            <router-link
                class="navbar-brand"
                v-bind:to="{ name: 'adm' }">
                Mimo & Ponto
            </router-link>
            <button
                class="btn btn-link btn-sm order-1 order-lg-0"
                id="sidebarToggle"
                @click="toggle()">
                <i class="fas fa-bars"></i>
            </button>

            <!-- Person-->
            <div class="d-none d-md-inline-block form-inline ml-auto mr-0 mr-md-3 my-2 my-md-0 text-light">
                {{ $auth.user.name }}
            </div>

            <!-- User icon -->
            <ul class="navbar-nav ml-auto ml-md-0">
                <li>
                    <notification-button></notification-button>
                </li>
                <li class="nav-item dropdown">
                    <a
                        class="nav-link dropdown-toggle"
                        id="userDropdown"
                        href="#"
                        role="button"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false">
                            <i class="fas fa-user fa-fw"></i>
                    </a>
                    <div
                        class="dropdown-menu dropdown-menu-right" aria-labelledby="userDropdown">
                        <router-link
                            class="dropdown-item"
                            v-bind:to="{ name: 'user' }">
                            Usuários
                        </router-link>
                        <!--<router-link
                            class="dropdown-item"
                            v-bind:to="{ name: 'config' }">
                            Configurações
                        </router-link>-->
                        <div class="dropdown-divider"></div>
                            <button
                                class="dropdown-item"
                                @click="logout()">
                                Sair
                            </button>
                    </div>
                </li>
            </ul>
        </nav>
	</div>
</template>

<script>
	export default {
		methods: {
			toggle(){
                $("body").toggleClass("sb-sidenav-toggled");
            },
            logout(){
                axios.post(this.$url+'/logout');
                window.location.href = this.$url;
            },
		}
	}
</script>
